import { Credito } from '../models';

/**
 * Qué muestra el módulo con la v2 encendida (FINA-3378), según el último crédito del tenant
 * (`GET /creditos/current` devuelve el último no borrado, en cualquier estado):
 *
 * | `credito.status`                         | Vista       |
 * |------------------------------------------|-------------|
 * | sin crédito, `eligible` (viva o vencida), `completed` | `line`: pantalla de línea con la calculadora según `canRequest` |
 * | `requested`                              | `in_review`: línea en resumen + «Solicitud en revisión» (todavía no hay cuotas: se crean al activarse) |
 * | `active`, `late`                         | `loan`: línea en resumen + dashboard de cuotas |
 *
 * Con la v2 no hay `eligible-modal`, ni aviso de oferta vencida, ni `completion-modal`.
 * Un estado que el front no conoce cae a la pantalla de línea: el servidor decide si se puede pedir.
 */
export type CreditLineView = 'line' | 'in_review' | 'loan';

export function resolveCreditLineView(credito: Pick<Credito, 'status'> | null | undefined): CreditLineView {
    switch (credito?.status) {
        case 'requested':
            return 'in_review';
        case 'active':
        case 'late':
            return 'loan';
        default:
            return 'line';
    }
}
